import { useLoginStore } from '@/login/stores/useLoginStore';
import type { Model } from '@/newApi/services/ResgateManager';
import { ResErr, ResgateManager } from '@/newApi/services/ResgateManager';
import { EmploymentSalaryType } from '@sysarb/sysarb-types/general/enums';
import type { EmploymentAndJobProfile } from '@sysarb/sysarb-types-v2/services/v1/job';
import type { QueryOptions } from '@tanstack/vue-query';
import { queryOptions } from '@tanstack/vue-query';

type EmploymentAndJobProfileOptions = {
    queries: {
        getEmploymentAndJobProfile: (employmentId: string | null | undefined, salaryType?: EmploymentSalaryType) => QueryOptions<Model<EmploymentAndJobProfile> | null, Error>;
    };
};

function getVersion(): 'v1' | 'v2' {
    return 'v2';
}

export const employmentAndJobProfile: EmploymentAndJobProfileOptions = {
    queries: {
        getEmploymentAndJobProfile: (employmentId: string | null | undefined, salaryType: EmploymentSalaryType = EmploymentSalaryType.monthly): QueryOptions<Model<EmploymentAndJobProfile> | null, Error> => {
            const { instanceTopic } = useLoginStore();
            const version = getVersion();
            const topic = `${version}.${instanceTopic}.employment.${employmentId}.job?salaryType=${salaryType}`;

            return queryOptions<Model<EmploymentAndJobProfile> | null, Error>({
                meta: {
                    subscribe: true,
                    type: 'resgate',
                    resourceId: topic,
                },
                queryKey: ['section-manager', 'employment-and-job-profile', topic],
                queryFn: async (): Promise<Model<EmploymentAndJobProfile> | null> => {
                    const res = await ResgateManager.model<EmploymentAndJobProfile>(topic);
                    if (res instanceof ResErr) throw new Error(res.message);
                    return res;
                },
                enabled: () => employmentId != null,
            });
        },
    },
};
